import { render, staticRenderFns } from "./UserRoleDropdown.vue?vue&type=template&id=11f3fe40&scoped=true&"
import script from "./UserRoleDropdown.vue?vue&type=script&lang=js&"
export * from "./UserRoleDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f3fe40",
  null
  
)

export default component.exports